import { __decorate } from "tslib";
import nmModuleCalc from './module.calc';
import * as CONST from './const';
import Utils from './utils';
import Reportable from './decorators/reportable';
import DefaultReturn from './decorators/defaultReturn';
class nmMuseCalcStartup {
    static setMobileDetect(func) {
        console.log(func, func());
        Utils.isMobile = func;
        console.log(Utils.isMobile, Utils.isMobile());
    }
    static getHash() {
        let hash = {};
        if (window.location.hash.length > 3) {
            const tmp = decodeURIComponent(window.location.hash.substr(1).replace(/\+/g, '%20'));
            hash = JSON.parse(tmp);
        }
        return hash;
    }
    static getHost(urlParams) {
        return (urlParams.get('env') === 'test' ? CONST.TEST_HOST : CONST.APP_HOST);
    }
    static getName(el) {
        let name = '';
        if (el && el.dataset && el.dataset.name) {
            name = el.dataset.name;
        }
        if (name && name.length > 3) {
            return name;
        }
        else if (window.CALCULATOR_NAME) {
            return window.CALCULATOR_NAME;
        }
        else {
            throw new Error('No calculator configuration name');
        }
    }
    static getPaspartuOverflow(el) {
        let paspartuOverflow = CONST.DEFAULT_PASPARTU_OVERFLOW;
        if (el && el.dataset && el.dataset.paspartuOverflow) {
            if (el.dataset.paspartuOverflow.toLowerCase() === 'true') {
                paspartuOverflow = true;
            }
            if (el.dataset.paspartuOverflow.toLowerCase() === 'false') {
                paspartuOverflow = false;
            }
        }
        return paspartuOverflow;
    }
    static getCustomCurrencySign(el) {
        if (el && el.dataset && el.dataset.currencySign && el.dataset.currencySign && el.dataset.currencySign !== '') {
            return el.dataset.currencySign;
        }
        return false;
    }
    static getTargetId(el) {
        let name = CONST.CONTAINER_ID;
        if (el && el.dataset && el.dataset.target) {
            name = el.dataset.target;
        }
        if (name && name.length > 3) {
            return name;
        }
        else {
            throw new Error('No calculator target name');
        }
    }
    static getParams(el) {
        const hash = this.getHash();
        const urlParams = new URLSearchParams(window.location.search);
        const HOST = this.getHost(urlParams);
        const SERVER = HOST + '/api/calc';
        const scrollToForm = Object.prototype.hasOwnProperty.call(hash, 'scrollToForm') ? hash.scrollToForm : false;
        let projectData = {};
        if (hash && hash.project) {
            projectData = hash.project;
        }
        const name = this.getName(el);
        const targetId = this.getTargetId(el);
        const paspartuOverflow = this.getPaspartuOverflow(el);
        const currencySign = this.getCustomCurrencySign(el);
        return {
            name, //code name to retrieve calculator configuration
            host: HOST, //api host
            server: SERVER, //api server end-point
            targetId,
            uniqueId: targetId, //container element id
            project: projectData, //additional options to default project or complete override project
            renderForm: true, //render user info form
            paspartuOverflow, //if true - paspartu be in border of selected size of image, false - will be added around
            preserveFormat: false, //if image should keep format when resized
            scrollToForm, //scroll to form after render
            currencySign,
            startUnder: false
        };
    }
    static start(el, overlay = false, startUnder = false) {
        const params = this.getParams(el);
        params.overlay = overlay;
        params.startUnder = startUnder;
        if (params) {
            this.registerCalculator(new nmModuleCalc(params));
            params.targetId && this.formFix(params.targetId);
            params.scrollToForm && this.scrollFix(params.scrollToForm);
        }
        else {
            throw new Error('No params to start nmQuickCalc');
        }
    }
    static inject(targetId, name) {
        const el = document.createElement('DIV');
        el.dataset.target = targetId;
        el.dataset.name = name;
        this.start(el);
    }
    static formFix(targetId) {
        let contEl = document.getElementById(targetId);
        if (!contEl) {
            return;
        }
        while (contEl?.id !== 'vertical-order-form' && contEl !== document.body) {
            contEl = contEl?.parentNode;
            if (!contEl) {
                return;
            }
        }
        if (contEl === document.body) {
            return;
        }
        contEl.setAttribute('novalidate', 'true');
        contEl.addEventListener('submit', (e) => {
            e.stopImmediatePropagation();
            mr.forms.submit(e);
            return false;
        });
    }
    static scrollFix(scrollToForm) {
        if (scrollToForm) {
            const el = document.getElementById('vertical-order-form');
            el && el.scrollIntoView(true);
        }
    }
    static registerCalculator(instance) {
        if (!window.CALCULATORS) {
            window.CALCULATORS = {};
        }
        window.CALCULATORS[instance.getName()] = instance;
    }
    static getCalculator(name) {
        if (window.CALCULATORS[name]) {
            return window.CALCULATORS[name];
        }
        throw new Error('Calculator not exists');
    }
}
__decorate([
    DefaultReturn(false),
    Reportable
], nmMuseCalcStartup, "getHash", null);
__decorate([
    DefaultReturn(CONST.APP_HOST),
    Reportable
], nmMuseCalcStartup, "getHost", null);
__decorate([
    DefaultReturn(''),
    Reportable
], nmMuseCalcStartup, "getName", null);
__decorate([
    DefaultReturn(CONST.CONTAINER_ID),
    Reportable
], nmMuseCalcStartup, "getTargetId", null);
__decorate([
    Reportable
], nmMuseCalcStartup, "getParams", null);
__decorate([
    Reportable
], nmMuseCalcStartup, "start", null);
__decorate([
    Reportable
], nmMuseCalcStartup, "inject", null);
__decorate([
    Reportable
], nmMuseCalcStartup, "formFix", null);
__decorate([
    Reportable
], nmMuseCalcStartup, "scrollFix", null);
export { nmMuseCalcStartup, nmModuleCalc };
